import React, { useContext, useState } from "react";
import { IonButton, IonIcon, isPlatform } from "@ionic/react";
import { shareOutline, shareSocial } from "ionicons/icons";
import { TranslationsContext } from "../util/Translations";
import ShareWorkOrderModal from "./ShareWorkOrderModal";

interface ShareWorkOrderButtonProps {
  woNumber: string;
  description?: string;
}

/**
 * Toolbar share control for a work order (US 379069). Opens the share-comment
 * modal, which then invokes the device's native / Web Share sheet (or copies
 * the deep link on desktop). Encapsulates its own open state and modal so it can
 * be dropped into any toolbar's trailing slot — WO Overview, WO Details, and the
 * requester variants — without each host managing share state.
 *
 * Uses the platform-appropriate glyph (FR / "use the appropriate icon for the
 * different devices"): the iOS share icon on iOS, the Android share icon
 * elsewhere.
 */
const ShareWorkOrderButton: React.FC<ShareWorkOrderButtonProps> = ({
  woNumber,
  description,
}) => {
  const { translations } = useContext(TranslationsContext);
  const [isOpen, setIsOpen] = useState(false);
  const shareLabel = translations["lbl_share"] || "Share";
  const icon = isPlatform("ios") ? shareOutline : shareSocial;

  return (
    <>
      <IonButton
        slot="end"
        fill="clear"
        onClick={() => setIsOpen(true)}
        title={shareLabel}
        aria-label={shareLabel}
      >
        <IonIcon slot="icon-only" icon={icon} />
      </IonButton>
      <ShareWorkOrderModal
        isOpen={isOpen}
        woNumber={woNumber}
        description={description}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default ShareWorkOrderButton;
